import React, { useContext } from "react";
import { Link } from "react-router-dom";
import UserContext from "../context/UserContext.js";
import useLikeSpace from "../hooks/useLikeSpace.js";
import useMarkSpaceVisited from "../hooks/useMarkSpaceVisited.js";
import "./SpaceCard.css";

/** Show info about space
 *
 * Rendered by SpacesList to show SpaceCard for each space.
 *
 * SpacesList -> SpaceCard
 */

const SpaceCard = ({ title, description, category, address, est_year, city, neighborhood, averageRating }) => {
  console.debug("SpaceCard", title);
  const { currentUser } = useContext(UserContext);

  const { isLiked, handleLikeClick } = useLikeSpace(currentUser, title);
  const { visited, visitDate, handleVisitClick } = useMarkSpaceVisited(currentUser, title);

  if (!currentUser) {
    return <p>Loading...</p>;
  }

  return (
    <div className="space-card">
      <div className="space-card-body">
        <div className="space-card-header">
          <Link className="space-card-title-link" to={`/spaces/${title}`}>
            <h3 className="space-card-title">{title}</h3>
          </Link>
          {averageRating && (
            <span className="space-card-rating">★ {parseFloat(averageRating).toFixed(1)}</span>
          )}
        </div>

        <p className="space-card-description">{description}</p>

        <div className="space-card-meta">
          {category && (
            <div className="space-card-meta-item">
              <span className="space-card-meta-label">Category</span>
              <Link className="space-card-meta-value" to={`/categories/${category}`}>{category}</Link>
            </div>
          )}
          <div className="space-card-meta-item">
            <span className="space-card-meta-label">Address</span>
            <Link className="space-card-meta-value" to={`/map/${title}`}>{address}</Link>
          </div>
          <div className="space-card-meta-item">
            <span className="space-card-meta-label">Year</span>
            <span className="space-card-meta-value">{est_year}</span>
          </div>
          {city && neighborhood && (
            <div className="space-card-meta-item">
              <span className="space-card-meta-label">Area</span>
              <Link className="space-card-meta-value" to={`/locations/spaces/${city}/${neighborhood}`}>
                {city}, {neighborhood}
              </Link>
            </div>
          )}
        </div>
      </div>

      <div className="space-card-actions">
        <button
          className="space-card-btn"
          onClick={handleVisitClick}
          disabled={visited}
        >
          {visited ? `✓ Visited ${visitDate}` : "Mark Visited"}
        </button>
        <button
          className={`space-card-btn ${isLiked ? "space-card-btn-liked" : ""}`}
          onClick={handleLikeClick}
        >
          {isLiked ? "♥ Liked" : "♡ Like"}
        </button>
      </div>
    </div>
  );
};

export default SpaceCard;
